import React from "react";
import {useRouter} from 'next/router';
import CasePage from '../../components/Case/CasePage';
import {fetchMeta} from '../../util/pages';
import {withUserGetServerSideProps} from '../../util/util';
import {wrapper} from '../../store/store';
import {fetchCasesById} from '../../features/thunks';

function Page() {
    const router = useRouter();

    const id = Array.isArray(router.query.id) ? router.query.id[0] : router.query.id;
    if (!id) {
        return null;
    }

    return <div>
        <CasePage id={id}/>
    </div>;
}

export const getServerSideProps = wrapper.getServerSideProps(withUserGetServerSideProps(async (ctx: any) => {
    const content = await fetchMeta();

    const caseId = ctx.query.id;

    if (caseId) {
        await ctx.store.dispatch(fetchCasesById({caseId}));
    }

    return { props: {content} }
}
))
export default Page;
